import React, { Suspense } from 'react'

import { Spin } from 'antd'
const Loading = () => (
  <div style={{ textAlign: 'center', margin: '20px auto' }}>
    <Spin />
  </div>
)

const LazyLoad = ({ component: Component, ...rest }) => (
  <>
    <Suspense fallback={<Loading />}>
      <Component {...rest} />
    </Suspense>
  </>
)

export default LazyLoad
